import {AbstractControl, ValidationErrors} from '@angular/forms';
import {HealthCenterShort} from '../../../health-center/services/http/health-center-short';

export function healthCenterValidator(control: AbstractControl): ValidationErrors | null {
  if (!(control.get('healthCenter')?.value instanceof HealthCenterShort)) {
    control.get('healthCenter')?.setErrors({incorrect: true});
  } else {
    control.get('healthCenter')?.setErrors(null);
  }

  return null;
}
